import React from "react";

const Button = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 bg-[#5DA3E9] text-white text-base font-bold rounded-md flex justify-center gap-4 max-w-[250px] min-w-[140px] max-h-[40px] transition-all duration-200 ease-in-out hover:bg-[#4a90d9] active:bg-[#3b7ac0] active:scale-95"
    >
      {children}
    </button>
  );
};

export default Button;
